import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  type MaybeAsync,
  type GuardResult,
} from "@angular/router";
import { AuthManager } from "../services/auth.service";
import { RegistrationReviewNotificationsService } from "../services/registration-review-notifications.service";

export const AuthGuard: CanActivateFn = (
  _route,
  state,
): MaybeAsync<GuardResult> => {
  const authService = inject(AuthManager);
  const router = inject(Router);
  const notifications = inject(RegistrationReviewNotificationsService);

  if (authService.isAuth()) {
    return true;
  }

  notifications.disconnect();
  const sessionExpired = authService.hasStoredToken();
  authService.cleanSession();

  return router.createUrlTree(["/login"], {
    queryParams: {
      returnUrl: state.url,
      ...(sessionExpired ? { sessionExpired: "1" } : {}),
    },
  });
};
